// "05 Mar, 2026"
export function formatDate(date) {
  const parts = new Intl.DateTimeFormat("en", { year: "numeric", month: "short", day: "2-digit" }).formatToParts(new Date(date));
  const get = (type) => parts.find((p) => p.type === type)?.value;
  return `${get("day")} ${get("month")}, ${get("year")}`;
}

// 12,345
export function formatNumber(number = 0) {
  return new Intl.NumberFormat().format(number);
}
